

















import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import buildTokenMixin from '@/Admin/TicketTemplate/TokenMixin';
import { CommandToken, Token } from '@/Admin/TicketTemplate/Types';
import I18nMixin from '@/Shared/I18nMixin';
import { SetTabs } from './Types';

export default mixins(I18nMixin, buildTokenMixin<SetTabs>()).extend({
    beforeMount() {
        // Prop type isn't recognized and I'm not sure why
        const tabs = (this.token as unknown as SetTabs).tabs ?? '';
        const binaryString = window.atob(tabs);
        const len = binaryString.length;
        const bytes = [];
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        this.tabBytes = bytes;
    },
    data() {
        return {
            tabBytes: [] as number[],
        };
    },
    computed: {
        i18nPrefix() {
            return 'admin.ticketTemplateBuilder.commandToken.commands';
        },
    },
    methods: {
        deleteTab(index: number) {
            this.tabBytes.splice(index, 1);
        },
        addTab() {
            this.tabBytes.push(0);
        }
    },
    watch: {
        tabBytes() {
            (this.token as unknown as SetTabs).tabs = btoa(String.fromCharCode(...this.tabBytes));
        }
    }
});
